import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faTimes, 
  faSearch, 
  faEnvelope, 
  faPhoneVolume, 
  faMapMarkerAlt 
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faTimes,
  faSearch,
  faEnvelope,
  faPhoneVolume,
  faMapMarkerAlt
);